import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService, OidcService } from '../services';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(readonly oidcService: OidcService, readonly authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.authService.accessToken;
    const accessTokenExpiry = Number(this.authService.accessTokenExpiry);
    const currentTime = Math.floor(Date.now() / 1000);

    // Refresh 1 minute before token expires
    if (accessToken && currentTime >= accessTokenExpiry - 60) {
      this.oidcService.refreshAccessToken();
    }
    const token = this.authService.getToken();

    const headersConfig: any = {
      'Content-Type': 'application/json',
    };

    if (req.headers.get('Content-Type') === 'multipart/form-data') {
      delete headersConfig['Content-Type'];
      const headers = {
        headers: req.headers.delete('Content-Type')
      };
      req = req.clone(headers);
    }

    if (accessToken && (req.url.includes(environment.api_url) || req.url.includes(environment.maintenanceUrl))) {
      headersConfig['Authorization'] = 'Bearer ' + accessToken;
    }

    if (token && req.url.includes(environment.api_url)) {
      headersConfig['SR-Authorization'] = token;
    }

    if (token && req.url.includes(environment.redeemptionUrl)) {
      headersConfig['Authorization'] = token;
    }

    const request = req.clone({ setHeaders: headersConfig });
    return next.handle(request);
  }
}
